export default __webpack_public_path__ + "static/media/schemat2.7c1d0e14.png";